const constants = {
  DATE_FORMAT: {
    FIELD: "DD/MM/YYYY",
    FIELD2: "DD-MM-YYYY",
    API: "YYYY-MM-DD",
  },
  DATETIME_FORMAT: {
    FIELD: "DD/MM/YYYY HH:mm",
    API: "YYYY-MM-DDTHH-mm",
    MUI: "YYYY-MM-DDTHH:mm",
  },
  DATETIME_FORMAT_FULL: {
    FIELD: "DD/MM/YYYY HH:mm:ss",
    API: "YYYY-MM-DDTHH-mm-ss",
    MUI: "YYYY-MM-DDTHH:mm:ss",
  },
  DAYS_BEFORE: 1,
  HOURS_BEFORE: 24,
  MINUTES_BEFORE: 30,
  LAYOUT: {
    EMPTY: "EMPTY",
    MAIN: "MAIN",
    SIMPLE: "SIMPLE",
  },
  MESSAGE: {
    ERROR_GETTING_DATA: "Ocorreu um erro na obtenção dos dados.",
    LOADING_DATA: "Carregando dados...",
    NO_REGISTERS: "Não foram encontrados registros.",
    ERROR_INVALID_INPUT:
      "Preencha os campos obrigatórios para efetuar a consulta.",
  },
  MOCK_ENABLED: "yes",
  FORMAT_EXHIBITION: {
    NUMBER: "numero",
    PERCENT: "percentual",
  },
  PAGINATION: {
    INITIAL_TOTAL: 0,
    INITIAL_PAGE: 1,
    PER_PAGE: 15,
  },
  PROJECT_TITLE: "CB Tracking",
  ROUTES: {
    CARGO_ROUTING: "/painel-de-cargas",
    HOME: "/",
    LOGIN: "/login",
    LOGOUT: "/logout",
    WELCOME: "/welcome",
  },
  STORAGE: {
    TOKEN_KEY: "@viaplca_token",
  },
  MASK_FIELD: "##########",
  SKELETON_CELLS: [0, 1, 2, 3],
  STATUS_SOLUCAO_ACAREACOES: {
    UPLOAD_COMPROVANTE: {
      descricao: "Recebido",
      colorRgb: "2, 122, 72",
    },
    ULTIMO_PONTO_NAO_ENT: {
      descricao: "Ponto não ENT",
      colorRgb: "16, 33, 155",
    },
    BAIXA_INDEVIDA: {
      descricao: "Baixa indevida",
      colorRgb: "187, 56, 45",
    },
    EXTRAVIO: {
      descricao: "Extravio",
      colorRgb: "255, 96, 0",
    },
    SEM_RESPOSTA: { descricao: "Sem resposta", colorRgb: "187, 56, 45" },
  },
  STATUS_ACAREACOES: {
    ABERTO: "Em aberto",
    ANDAMENTO: "Em andamento",
    FINALIZADO: "Finalizado",
    FORA_PRAZO: "Fora do prazo",
  },
  UF_LISTA: [
    "AC",
    "AL",
    "AM",
    "AP",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MG",
    "MS",
    "MT",
    "PA",
    "PB",
    "PE",
    "PI",
    "PR",
    "RJ",
    "RN",
    "RO",
    "RR",
    "RS",
    "SC",
    "SE",
    "SP",
    "TO",
  ],
};

export default constants;
